Jelly.Actions =  {
	Email_Validator: new RegExp('^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$', 'i')
};